var React = require('react');

function RectangleTriangleMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M151.62 126.209L162.617 262.749L-1.56847e-06 120.974L151.62 126.209Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M255.492 68.6244L162.446 262.845L151.523 126.478L255.492 68.6244Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M255.488 68.624L151.592 126.437L0.00129089 120.972L255.488 68.624Z","fill":"#5915C7","key":2})]);
}

RectangleTriangleMobile.defaultProps = {"width":"216","height":"299","viewBox":"0 0 216 299","fill":"none"};

module.exports = RectangleTriangleMobile;

RectangleTriangleMobile.default = RectangleTriangleMobile;
